import { render, staticRenderFns } from "./SectionTime.vue?vue&type=template&id=4f4461d8"
import script from "./SectionTime.vue?vue&type=script&lang=ts"
export * from "./SectionTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports